import { MASCOT } from "@/lib/api";

export function ProcessingView({ product }) {
  return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center">
      <img src={MASCOT.happy} alt="Solange" className="w-40 h-40 object-cover rounded-full mx-auto animate-float-slow" />
      <h1 className="mt-6 font-display text-3xl font-bold text-[#9c5f27]">Solange está trabalhando...</h1>
      <p className="mt-3 text-[#5c4634]" data-testid="processing-message">
        {product.progress_message || "Preparando tudo pra você."}
      </p>
      <div className="mt-8 h-2 rounded-full bg-[#f5ebe1] overflow-hidden max-w-sm mx-auto">
        <div className="h-full bg-[#f0791f] animate-pulse" style={{ width: "70%" }} />
      </div>
      <p className="mt-4 text-sm text-[#8c735f]">Isso pode levar cerca de um minuto. Pode deixar essa tela aberta.</p>
    </div>
  );
}
